import React, { ReactNode, useCallback } from 'react';

import { useOneClick } from 'Shared/utils/hooks';

import './CircleSignUpButton.scss';

type Props = {
  color: string;
  logo: ReactNode;
  label: string;
  signUpUrl: string;
};

function CircleSignUpButton({ color, logo, label, signUpUrl }: Props) {
  const handleClick = useCallback(() => {
    window.location.href = signUpUrl;
  }, [signUpUrl]);

  const [onOneClick] = useOneClick({ onClick: handleClick });

  return (
    <button
      type="button"
      className="btn btn-link p-0 circle-sign-up-button-container d-flex flex-column align-items-center"
      onClick={onOneClick}
    >
      <div className="circle-sign-up-button circle">
        <div className="bg-white w-100 h-100 circle">
          <div className="w-100 h-100 circle d-flex" style={{ backgroundColor: color }}>
            {logo}
          </div>
        </div>
      </div>
      <div className="circle-sign-up-button-label mt-2 text-center">{label}</div>
    </button>
  );
}

export default CircleSignUpButton;
